// Bundled owner of the inline↔bundle asset-rescue protocol markers.
//
// The same-origin watchdog (assetRescueWatchdog.inline.js — the canonical
// design reference) ships untranspiled inside the HTML, so it must hardcode
// these names on its side; every BUNDLED module reads them through here so
// the protocol lives in exactly two files. Keep the two in sync.

// Attribute the watchdog stamps on every tag it injects.
export const RESCUE_ATTR = 'data-asset-rescue';

// Set by the watchdog the moment a rescue activates, before any GCS tag is
// injected — so rescued pack code observes it from its very first statement.
export const isAssetRescueActive = () => {
  try {
    // eslint-disable-next-line no-underscore-dangle
    return Boolean(window.__m8AssetRescueActivated);
  } catch {
    return false;
  }
};

export default isAssetRescueActive;
